__turbopack_context__.v({
  "container": "bordered-cta-container-module-scss-module__x0GsEq__container",
  "description": "bordered-cta-container-module-scss-module__x0GsEq__description",
  "title": "bordered-cta-container-module-scss-module__x0GsEq__title",
});
